import type { Maybe } from '@nova/core';

import { toPresenterPlaceholder } from '@satellite/composables/presenterV2Placeholder';

import type { PresenterPlaceholderData } from '@satellite/composables/presenterV2Placeholder';
import type { YardAreaDetails } from '@satellite/composables/useYardAreaPresenterV2';
import type { YardAssetDetails } from '@satellite/composables/useYardAssetPresenterV2';
import type { YardSpotDetails } from '@satellite/composables/useYardSpotPresenterV2';

/**
 * Maps check-task `relatedObject` into `YardAreaPresenterV2` placeholder / initial data.
 */
export function relatedObjectToYardArea(
  related: Maybe<{ id: string; name?: string }>
): PresenterPlaceholderData<YardAreaDetails> | undefined {
  if (!related?.id) {
    return;
  }

  return toPresenterPlaceholder<YardAreaDetails>({ id: related.id, name: related.name });
}

/**
 * Maps check-task `relatedObject` into `YardSpotPresenterV2` placeholder / initial data.
 */
export function relatedObjectToYardSpot(
  related: Maybe<{ id: string; code?: string; type?: string; spotAreaId?: string }>
): PresenterPlaceholderData<YardSpotDetails> | undefined {
  if (!related?.id) {
    return;
  }

  return toPresenterPlaceholder<YardSpotDetails>({
    id: related.id,
    code: related.code ?? '',
    type: related.type ?? '',
    spotAreaId: related.spotAreaId ?? ''
  });
}

/**
 * Maps check-task `relatedObject` into `YardAssetPresenterV2` placeholder / initial data.
 */
export function relatedObjectToYardAsset(
  related: Maybe<{ id: string; code?: string; type?: string }>
): PresenterPlaceholderData<YardAssetDetails> | undefined {
  if (!related?.id) {
    return;
  }

  return toPresenterPlaceholder<YardAssetDetails>({
    id: related.id,
    code: related.code,
    type: related.type
  });
}
